import React from 'react';

function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-primary-50 to-accent-50">
      <div className="text-center">
        <div className="relative w-16 h-16 mx-auto mb-4">
          <div className="absolute inset-0 bg-gradient-to-r from-primary-600 to-accent-600 rounded-full animate-spin"></div>
          <div className="absolute inset-1 bg-white rounded-full"></div>
        </div>
        <h2 className="text-xl font-semibold text-gray-800">Loading</h2>
        <p className="text-gray-600 text-sm mt-2">Please wait while we prepare your dashboard...</p>
      </div>
    </div>
  );
}

export default LoadingSpinner;
